module.exports = __webpack_public_path__ + "img/ford_thumbnail.06900034.png";